<template>
    <div class="layout-promo">

        <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${page.heroImage.large4x3})`}" v-if="!!page.heroImage && page.heroImage.id > 0">
            <div class="uk-grid uk-margin-xlarge-top" uk-grid>
                <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">

                    <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                    <h1 class="uk-margin-small-top">{{page.title}}</h1>

                    <slot name="summary">
                        <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
                    </slot>

              </div>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-else>
          <div class="uk-light uk-container uk-container-small uk-text-center">

              <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
              <h1 class="uk-margin-small-top">{{page.title}}</h1>

              <slot name="summary">
                  <p class="uk-text-lead" v-if="page.subtitle">{{page.subtitle}}</p>
              </slot>

              <slot name="subheader"></slot>
          </div>
        </div>

        <div class="uk-section uk-section-small uk-background-darkest uk-text-center uk-light" v-if="page.summary">
            <div class="uk-container uk-container-small">
                <h3 class="uk-margin-remove"><em class="text-green">{{page.summary}}</em></h3>
            </div>
        </div>

        <div class="uk-section uk-background-lightest uk-dark" v-if="readOnePromo && readOnePromo.MailchimpList">
            <div class="uk-container uk-container-small">

                <img :src="page.Image.Medium" class="uk-thumbnail uk-margin-bottom" v-if="page.Image && page.Image.Medium" />

                <div class="content" v-html="page.content" v-if="page.content"></div>

                <div class="uk-alert uk-alert-danger" v-if="errors.length > 0">
                    <span v-for="error in errors">{{error}}&nbsp;</span>
                </div>

                <!-- Begin MailChimp Signup Form -->
                <div id="mc_embed_signup">
                <form :action="`https://lowellmilkencenter.us8.list-manage.com/subscribe/post?u=36b8acb32d8db6c72ab507565&amp;id=${readOnePromo.MailchimpList}`" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate="" @submit="checkForm">

                    <div class="uk-margin">
                      <input class="required email uk-input" type="email" name="EMAIL" id="mce-EMAIL" placeholder="Email*" v-model="email" required=""></div>
                    <div class="uk-margin">
                        <div class="uk-grid" uk-grid="">
                            <div class="uk-width-1-2@m">
                                <input class="uk-input" type="text" name="FNAME" id="mce-FNAME" placeholder="First Name*" v-model="firstname" required=""></div>
                            <div class="uk-width-1-2@m">
                                <input class="uk-input" type="text" name="LNAME" id="mce-LNAME" placeholder="Last Name*" v-model="lastname" required=""></div>
                        </div>
                    </div>

                     <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                    <div id="mce-responses" class="clear">
                      <div class="response" id="mce-error-response" style="display:none"></div>
                      <div class="response" id="mce-success-response" style="display:none"></div>
                    </div>

                    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_36b8acb32d8db6c72ab507565_444509bbfe" tabindex="-1" value=""></div>

                    <input class="uk-button theme-button button-green uk-width-1-1" type="submit" value="Subscribe now" name="subscribe" id="mc-embedded-subscribe"></form>
                </div>
            </div>
        </div>

        <div class="uk-section uk-section-medium uk-background-darkest uk-light" v-if="page.secondaryContent">
            <div class="uk-container uk-container-small">
                <div class="content" v-html="page.secondaryContent"></div>
            </div>
        </div>

        <Testimonials :testimonials="(page && page.testimonialsArray) ? JSON.parse(page.testimonialsArray, true) : false" />

    </div>
</template>

<script>
import gql from 'graphql-tag'

// GraphQL query
const readPromoQuery = gql`
    query($id: ID!) {
      readOnePromo(ID: $id){
        MailchimpList
      }
    }
`

export default {
    data() {
        return {
            readOnePromo: {},
            firstname: "",
            lastname: "",
            email: "",
            errors: []
        }
    },
    inject: [ 'api', 'theme' ],
    props: ['page', 'parent'],
    apollo: {
        readOnePromo: {
            query: readPromoQuery,
            variables() {
                return {
                    id: this.page.id
                }
            },
            loadingKey: 'loading'
        }
    },
    methods:{
    checkForm:function(e) {
      if(this.firstname && this.lastname && this.email) return true;
      this.errors = [];
      if(!this.firstname) this.errors.push("First Name required.");
      if(!this.lastname) this.errors.push("Last Name required.");
      if(!this.email) this.errors.push("Email required.");
      e.preventDefault();
    }
  }
}
</script>
